import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { TextField, Button, Paper, Grid, Typography, MuiThemeProvider } from '@material-ui/core';
import Fade from 'react-reveal/Fade';
import RubberBand from 'react-reveal/RubberBand';
import InputMask from 'react-input-mask';

class home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            roomCode: "",
            notHost: true
        }
    };
 
    handleChange = (e) => {
        this.setState({ roomCode: e.target.value }, () => this.props.setRoomCode(this.state.roomCode));
    };

    handleHostButtonClick = (e) => {
        this.props.setName("Game Master");
        this.props.setRoomCode(Math.random().toString(6).substring(2, 6));
        this.props.setHost(true);
        this.props.play();
    };

    handleJoinButtonClick = (e) => {
        this.setState({notHost: false});
        this.props.setHost(false);
    };

    render() {
        const { props } = this;
        const { classes } = this.props;
        return (
            <MuiThemeProvider theme={this.props.theme}>
                <div>
                    <Paper className={classes.header}>
                        { this.state.notHost ?
                            <Grid style={{ textAlign: "center" }} container spacing={2}>
                                <Grid item xs={12}>
                                    <Fade top>
                                        <Typography
                                            color="secondary"
                                            variant="h5"
                                        >
                                            Prompt Draw
                                        </Typography>
                                    </Fade>
                                </Grid>
                                <Grid item xs={12}>
                                    <Fade>
                                        <Button
                                            onClick={this.handleHostButtonClick}
                                            variant="outlined"
                                            color="secondary"
                                            className={classes.bigButtons}
                                        >
                                            <div style={{display: "block"}}>
                                                <p className={classes.bigButtonBigText}>HOST GAME</p>
                                                <p className={classes.bigButtonSmallText}>(This will be the display device)</p>
                                            </div>
                                        </Button>
                                    </Fade>
                                </Grid>
                                <Grid item xs={12}>
                                    <Fade>
                                        <Button
                                            onClick={this.handleJoinButtonClick}
                                            variant="outlined"
                                            color="secondary"
                                            className={classes.bigButtons}
                                        >
                                            <div style={{display: "block"}}>
                                                <p className={classes.bigButtonBigText}>JOIN GAME</p>
                                                <p className={classes.bigButtonSmallText}>(Connect to hosting device)</p>
                                            </div>
                                        </Button>
                                    </Fade>
                                </Grid> 
                            </Grid>
                            :
                            <Grid style={{ textAlign: "center" }} container spacing={2}>
                                <Grid item xs={12}>
                                    <Fade top>
                                        <Typography
                                            color="secondary"
                                            variant="h5"
                                        >
                                            Prompt Draw
                                        </Typography>
                                    </Fade>
                                </Grid>
                                <Grid item xs={12}>
                                    <Fade bottom>
                                        <TextField
                                            autoFocus
                                            label="Player Name"
                                            placeholder="Dat Boi!"
                                            className={classes.textField}
                                            inputProps={{ maxLength: 25 }}
                                            onChange={(e) => props.setName(e.target.value)}
                                        />
                                    </Fade>
                                </Grid>
                                <Grid item xs={12}>
                                    <Fade bottom>
                                        <InputMask
                                            mask="9999"
                                            value={this.state.roomCode}
                                            disabled={false}
                                            maskChar=""
                                            onChange={(e) => this.handleChange(e)}
                                        >
                                            {() => <TextField
                                                required
                                                label="Room Code"
                                                helperText="Room Code is located on screen of the started host."
                                                className={classes.textField}
                                                inputProps={{ maxLength: 4 }}
                                                onKeyDown={(e) => {e.keyCode === 13 && this.state.roomCode.length >3 && props.play()}}
                                            />}
                                        </InputMask>
                                    </Fade>
                                </Grid>
                                <Grid item xs={12}>
                                    <Fade bottom>
                                        <RubberBand spy={this.state.roomCode.length > 3}>
                                            <Button
                                                onClick={props.play}
                                                variant="outlined"
                                                color="secondary"
                                                className={classes.textField}
                                                disabled={this.state.roomCode.length <= 3}
                                            >
                                                JOIN
                                            </Button>
                                        </RubberBand>
                                    </Fade>
                                </Grid>
                                <Grid className={classes.footer} item container spacing={1} xs={12}>
                                    <Grid item xs={12}>
                                        <Fade>
                                            <Typography
                                                variant="h6"
                                                color="primary"
                                            >
                                                By Boulder Dynasty Studios
                                            </Typography>
                                        </Fade>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Fade>
                                            <Typography
                                                variant="caption"
                                                color="primary"
                                            >
                                                Special thanks to Carston, Jordan, and Scott Dastrup.
                                            </Typography>
                                        </Fade>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                    </Paper>
                </div>
            </MuiThemeProvider>
        );
    };
};

const styles = theme => ({
    header: {
        marginTop: 50,
        marginLeft: 20,
        marginRight: 20
    },
    textField: {
        width: 200
    },
    footer: {
        marginTop: 50
    },
    bigButtons: {
        width: 200,
        height: 200
    },
    bigButtonBigText:{
        fontSize: 'large'
    },
    bigButtonSmallText: {
        fontSize: 'x-small'
    }
});

export default withStyles(styles)(home);